/**
 * @generated SignedSource<<2a7b2ccb0b3382311906a39fd9ae8621>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutTaxExemption_viewer$data = {
  readonly taxExemptCertificateUploadFF: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutTaxExemptionCheckbox_viewer">;
  readonly " $fragmentType": "CheckoutTaxExemption_viewer";
};
export type CheckoutTaxExemption_viewer$key = {
  readonly " $data"?: CheckoutTaxExemption_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutTaxExemption_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutTaxExemption_viewer",
  "selections": [
    {
      "alias": "taxExemptCertificateUploadFF",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "taxExemptCertificateUpload"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"taxExemptCertificateUpload\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutTaxExemptionCheckbox_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "e1182907c1764ee15d758e162f99bdd1";

export default node;
